import React from 'react'
import styled from 'styled-components'

import Color from 'helpers/Color'

const labelWidth = '110px'

const Input = styled.input.attrs({
  type: 'text',
})`
  border: 0;
  border-bottom: ${({disabled}) => disabled ? 0 : `solid 2px ${Color.gray}`};
  width: calc(100% - ${labelWidth});
  width: ${({withLabel}) => withLabel ? `calc(100% - ${labelWidth})` : '100%'};
  height: ${({big}) => big ? 40 : 25}px;
  font-size: ${({big}) => big ? 1.2 : 1}em;
  padding-left: ${({big}) => big ? 10 : 0}px;

`
const Label = styled.div`
  width: ${labelWidth};
  display: inline-block;
  text-align: right;
  padding-right: 10px;
`
const Wrapper = styled.div`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`

const FormText = ({ label, value, big, onChange, ...rest }) => (
  <Wrapper>
    { label && <Label>{`${label}:`}</Label> }
    <Input
      big={big}
      withLabel={label}
      value={value || ''}
      onChange={event => onChange(event.target.value)}
      {...rest}
    />
  </Wrapper>
)

export default FormText



// WEBPACK FOOTER //
// ./src/components/UI/Form/FormText.jsx